import { render, staticRenderFns } from "./RecipientCriteria.vue?vue&type=template&id=65e007b0&scoped=true&"
import script from "./RecipientCriteria.vue?vue&type=script&lang=js&"
export * from "./RecipientCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e007b0",
  null
  
)

export default component.exports